import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import PopUp from "@components/PopUp";
import { clearStateAndPersist, RootState } from "@store/store";
import Img from "@assets/img";

import * as S from "./style";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { EAppAction } from "@store/appReducer";
import DashboardConstant from "@views/Pages/Dashboard/landing-image.constant";
import { Inbox } from "@novu/react";
import { jwtDecode } from "jwt-decode";
import AppearanceInbox from "../HeaderBar/inbox.style";
import * as Z from "../../components/PopUp/style";
import { PopUpContainer } from "@components/Navigate";
import { ThemeLogoFromCssVar } from "@components/HeaderBar/imageTheme";


const applicationIdentifier =
  process.env.REACT_APP_NOVU_APPLICATION_IDENTIFIER || "";

const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Navigate: React.FC = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state: RootState) => state.auth.token);
  const navigate = useNavigate();
  const location = useLocation();
  const [isClick, setIsClick] = useState(false);
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [subscriberId, setSubscriberId] = useState("");
  const [subscriberIdHash, setSubscriberIdHash] = useState("");

  const [activeBg, setActiveBg] = useState(false);

  useEffect(() => {
    const checkActiveBg = () => {
      const found = document.querySelector('.activeBg');
      setActiveBg(!!found);
    };
    checkActiveBg();

    const observer = new MutationObserver(() => {
      checkActiveBg();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, [activeBg]);


  const decodedToken = () => {
    if (isLoggedIn) {
      const decoded: any = jwtDecode(isLoggedIn);
      setSubscriberId(decoded.subId);
      setSubscriberIdHash(decoded.subIdHash);
    }
  };

  const onOpenReferPopup = () => {
    if (!isLoggedIn) {
      navigate("/login");
      return;
    }
    dispatch({
      type: EAppAction.SHOW_REFER_POPUP,
      payload: true,
    });
  };
  const handleNavigate = (tab: string) => {
    setIsClick(!isClick);
    navigate(tab);
  };

  const logout = () => {
    setVisiblePopup(false);
    clearStateAndPersist();
    navigate("/");
  };
  useEffect(() => {
    decodedToken();
  }, [isLoggedIn]);
  return (
    <S.Wrapper>
      <S.Container>
        <ThemeLogoFromCssVar style={{ width: "var(--header-logo-size)" }} header={true} />
        <S.NavUserContainer>
          {/* <S.UserNotification bellColor={"var(--primary-color)"}> */}
          {subscriberId && subscriberIdHash && (
            <Inbox
              applicationIdentifier={applicationIdentifier}
              subscriberId={subscriberId}
              subscriberHash={subscriberIdHash}
              appearance={AppearanceInbox.appearanceInbox}
            />
          )}
          {/* </S.UserNotification> */}

          <S.Hamburger onClick={() => setIsClick(!isClick)} style={{ cursor: "pointer", }}>
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-label="Open menu"
            >
              <rect y="7" width="32" height="3" rx="1.5" fill={"var(--primary-color)"} />
              <rect y="15" width="32" height="3" rx="1.5" fill={"var(--primary-color)"} />
              <rect y="23" width="32" height="3" rx="1.5" fill={"var(--primary-color)"} />
            </svg>
          </S.Hamburger>
        </S.NavUserContainer>
      </S.Container>
      <S.NaviMoblie className={isClick ? "display" : "none"}>
        <S.Close onClick={() => setIsClick(!isClick)} style={{ cursor: "pointer", color: "black" }}>
          <CloseIcon />
        </S.Close>
        <S.Content>
          <h1>Dashboard</h1>

          {/* Games Lobby */}
          <p
            onClick={() => handleNavigate("/dashboard")}
            className={location.pathname === "/dashboard" ? "active" : ""}
          >
            Games Lobby
          </p>

          {/* My Tickets */}
          <p
            onClick={() => handleNavigate("/ticket")}
            className={location.pathname === "/ticket" ? "active" : ""}
          >
            My Tickets
          </p>

          {/* Results */}
          <p
            onClick={() => handleNavigate("/raffle-result")}
            className={location.pathname === "/raffle-result" ? "active" : ""}
          >
            Results
          </p>

          {/* Ticket Generator */}
          <p
            onClick={() => handleNavigate("/ticket-generator")}
            className={location.pathname === "/ticket-generator" ? "active" : ""}
          >
            Ticket Zone
          </p>

          <p
            onClick={() => handleNavigate("/profile")}
            className={location.pathname === "/profile" ? "active" : ""}
          >
            My Profile
          </p>

          {/* Contact Us */}
          <p
            onClick={() => handleNavigate("/contact")}
            className={location.pathname === "/contact" ? "active" : ""}
          >
            Contact Us
          </p>

          <p
            onClick={() => (window.location.href = "https://www.daburshop.com")}
            className={location.pathname === "/contact" ? "active" : ""}
          >
            Go to Daburshop
          </p>
          {isLoggedIn && <p onClick={() => setVisiblePopup(true)}>Log out</p>}
        </S.Content>
        {/* <S.User>
          {isLoggedIn && <p onClick={() => setVisiblePopup(true)}>Log out</p>}
        </S.User> */}
      </S.NaviMoblie>
      <PopUp
        visible={visiblePopup}
        title=""
        footer={false}
        onOk={() => {
          setVisiblePopup(false);
          logout();
        }}
        onCancel={() => setVisiblePopup(false)}
        okText="No"
        cancelText="Yes"
      >
        <div className="relative w-full max-w-lg mx-auto overflow-hidden" onClick={() => setVisiblePopup(false)}>
          {/* Green gradient background card */}
          <div className="relative bg-gradient-to-br from-[#4B975B] via-[#5dad6d] to-[#4B975B] rounded-3xl p-8 md:p-10"
            onClick={(e) => e.stopPropagation()}>
            {/* Decorative background pattern */}
            <div className="absolute inset-0 opacity-10 pointer-events-none">
              <div className="absolute top-0 left-0 w-48 h-48 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
              <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-white rounded-full -translate-x-1/2 -translate-y-1/2 opacity-50"></div>
            </div>

            {/* Content */}
            <div className="relative z-10 space-y-6">
              {/* Icon with glow effect */}
              <div className="flex justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-white/30 rounded-full blur-xl"></div>
                  <div className="relative w-20 h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center border-2 border-white/30 shadow-xl">
                    <svg
                      className="w-10 h-10 text-white drop-shadow-lg"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2.5}
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Title */}
              <div className="text-center space-y-2">
                <h2 className="text-3xl md:text-4xl font-extrabold text-white drop-shadow-md">
                  Confirm Logout
                </h2>
                <p className="text-base md:text-lg text-white/95 leading-relaxed max-w-md mx-auto">
                  You're about to end your session. Are you sure you want to log out?
                </p>
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row justify-center items-stretch gap-4 pt-2">
                <button
                  onClick={() => {
                    setVisiblePopup(false);
                  }}
                  className="group relative px-8 py-4 bg-white text-[#4B975B] rounded-xl font-bold text-base md:text-lg shadow-xl hover:shadow-2xl hover:scale-105 active:scale-100 transition-all duration-300 min-w-[160px] overflow-hidden"
                >
                  <span className="relative z-10">Cancel</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-white to-gray-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </button>
                <button
                  onClick={() => {
                    setVisiblePopup(false);
                    logout();
                  }}
                  className="group relative px-8 py-4 bg-white/20 backdrop-blur-md border-2 border-white/50 text-white rounded-xl font-bold text-base md:text-lg shadow-xl hover:bg-white/30 hover:border-white hover:shadow-2xl hover:scale-105 active:scale-100 transition-all duration-300 min-w-[160px]"
                >
                  <span className="relative z-10">Yes, Log Out</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </PopUp>
    </S.Wrapper>
  );
};

export default Navigate;
